import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { environment } from "@env/environment";
import { MobileLabelsService } from "./service/mobile-labels-service.service";
import { LoaderService } from "./../../../../core/services/loader.service";
import { BroadcasterService } from "./../../../../core/services/broadcaster.service";
import { GenericUtils } from "./../../../utilities/";
import { LocalStorageService } from "./../../../services/local-storage.service";
import { MessageService } from './../../../services/message-service';
import * as moment from "moment";

@Component({
  selector: 'mobile-labels',
  templateUrl: './mobile-labels.component.html',
  styleUrls: ['./mobile-labels.component.scss']
})
export class MobileLabelsComponent implements OnInit, OnChanges, OnDestroy {

  unSortedData = [];
  baseUrl = environment.gateWayHost;


  @Input() apiUrl: string = "";
  @Input() model: string = "";
  @Input() filterKey: string = "";
  @Input() queryParams: object = {};
  @Input() label: string = "";
  @Input() resetValue;
  @Input() validFilters = [];
  @Input() validFiltersSkip = false;

  i = 0;


  // @Input() activeLabel: boolean = false;
  // @Input() filterType = "";
  // @Input() value = "";
  @Input() filterHandle;

  @Output() select: EventEmitter<any> = new EventEmitter();
  @Output() dataReset: EventEmitter<any> = new EventEmitter();

  // @Output() valueChanged = new EventEmitter();
  // @Output() ddClickedEvent = new EventEmitter();

  //Date-range

  getday;

  defaultValueField;
  constructor(
    private dataService: MobileLabelsService,
    private loader: LoaderService,
    private genericUtils: GenericUtils,
    private cd: ChangeDetectorRef,
    private message: MessageService
  ) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.filterHandle.type === "drop-down") {
      if (changes['validFilters'] &&
        JSON.stringify(changes['validFilters']['value'])
        !==
        JSON.stringify(changes['validFilters']['previousValue'])
        && !changes['validFilters']['firstChange']) {

        this.filterHandle.data = [];
        this.setValidFilters();
      }
      const changeKey = Object.keys(changes);
      if ((this.apiUrl && !this.resetValue || !this.filterHandle['data']) && (changeKey[0] != 'validFilters' || changeKey.length > 1)) { // second condition is for initialization
        this.getDataFromApi();
      }
      if ((changeKey[0] === 'validFilters' || changeKey.length === 1)) {
        this.setValidFilters();
      }
      if (this.resetValue && this.filterHandle['data'] && this.filterHandle['data'].length) {
        this.filterHandle.value = "";
        this.dataReset.emit(this.filterHandle);
      }
    }

  }

  setValidFilters() {
    const filterWithData = [];
    const filterWithoutData = [];

    this.unSortedData.map(element => {
      let tempValue, tempLabel;
      if (this.filterHandle.typeOfData === 'object') {
        tempValue = element.client_facility_code;
        tempLabel = `${element.client_facility_code}/ ${element.client_facility_name}`;
      } else {
        tempValue = element;
        tempLabel = element;
      }
      if (this.validFilters.includes(element) || this.validFiltersSkip) {
        filterWithData.push({ 'label': tempLabel, 'value': tempValue, 'disabled': false })
      } else {
        filterWithoutData.push({ 'label': tempLabel, 'value': tempValue, 'disabled': true })
      }
    })
    const tempData = filterWithData.concat(filterWithoutData);
    tempData.unshift({ 'label': 'ALL', 'value': '', 'disabled': false });
    this.filterHandle['data'] = tempData;
  }


  getDataFromApi() {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${this.apiUrl}`,
      query:
        this.queryParams && Object.keys(this.queryParams).length
          ? this.genericUtils.cleanParameters(this.queryParams)
          : {}
    };
    this.filterHandle['data'] = [];

    this.dataService
      .getDropDownData(this.genericUtils.cleanParameters(option))
      .subscribe(
        (response: any) => {
          this.loader.stop();

          if (
            response["data"] &&
            Array.isArray(response["data"]) &&
            response["data"].length
          ) {
            this.unSortedData = response["data"][0]["filters"];
            this.setValidFilters();
          }
        },
        error => {
          this.filterHandle['data'].push({ 'label': 'ALL', 'value': '', 'disabled': false });
          this.loader.stop();

        }
      );
  }


  refreshValue(value) {
    if (value) {
      if (value === "ALL") {
        value = "All";
        this.filterHandle.value = '';
      }
    }
  }

  selected() {
    this.select.emit(this.filterHandle);
  }

  ngOnDestroy() {
    this.filterHandle = null;
  }
}
